import { render, staticRenderFns } from "./appTypeDetail.vue?vue&type=template&id=4fae71cc&scoped=true"
import script from "./appTypeDetail.vue?vue&type=script&lang=js"
export * from "./appTypeDetail.vue?vue&type=script&lang=js"
import style0 from "./appTypeDetail.vue?vue&type=style&index=0&id=4fae71cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fae71cc",
  null
  
)

export default component.exports